export enum FeedbackStatus {
  TODO = 'TODO',
  COMPLETED = 'COMPLETED',
  TO_REVIEW = 'TO_REVIEW',
  REVIEWED = 'REVIEWED',
  ARCHIVED = 'ARCHIVED',
  KO_CANNOT_CONTACT = 'KO_CANNOT_CONTACT',
}
